import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionSectionService } from '../../shared/services/index';
import { InspectionSection } from '../../shared/models/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './new.component.html',
    standalone: false
})
export class NewSectionPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  public processing = false;
  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private sectionService: InspectionSectionService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      this.initData();
    });
  }

  initData(): void {}

  create(section: InspectionSection): void {
    this.processing = true;
    this.sectionService
      .newSection(this.inspectionId, { name: section.name, description: section.description })
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel(): void {
    this.goToBack();
  }
}
